
/**
 * PropertyBooleanField - Reusable checkbox field for garden object properties
 *
 * @param {string} label - Field label
 * @param {boolean} value - Current value
 * @param {function} onChange - Callback(newValue) when value changes
 * @param {boolean} disabled - Whether field is disabled
 */
const PropertyBooleanField = ({
  label,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-4 h-4 text-emerald-600 border-gray-300 rounded
          focus:ring-2 focus:ring-emerald-500
          disabled:opacity-50 disabled:cursor-not-allowed"
        id={`checkbox-${label.replace(/\s+/g, '-')}`}
      />
      <label
        htmlFor={`checkbox-${label.replace(/\s+/g, '-')}`}
        className="ml-2 text-sm text-gray-700 cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
};

export default PropertyBooleanField;
